import { Archive, Trash } from 'phosphor-react';
import React from 'react';
import { mosaiqTheme } from '../../theme';
import MultiSelectionMenu from './MultiSelectionMenu';

export default {
  title: 'Navigation/Multi Selection Menu',
  component: MultiSelectionMenu,
  argTypes: {},
  parameters: {
    design: {
      type: 'figma',
      url: 'https://www.figma.com/file/WZTA2cVbUPSOu4DQtALgcy/Dashboard?type=design&node-id=433-26733&mode=design&t=oWU7ypcyYX2N8Y0t-0',
    },
  },
};

const defaultArgs = {
  selectedIds: ['288389893h9d9ud92jdj', 'sdhksd9u9wkskjljfk'],
  onCancelSelection: () => {
    console.log('cancel selection clicked');
  },
  onSelectAll: () => {
    console.log('select all clicked');
  },
};

export const Default = {
  args: { ...defaultArgs },
};

export const Options = {
  args: {
    ...defaultArgs,
    options: [
      {
        text: 'Archive',
        icon: <Archive size={16} color={mosaiqTheme.colors.passive} />,
        action: () => {
          console.log('option  clicked');
        },
      },
      {
        text: 'Remove',
        icon: <Trash size={16} color={mosaiqTheme.colors.passive} />,
        action: () => {
          console.log('option  clicked');
        },
      },
    ],
  },
};
